import React, { useEffect, useState } from 'react';
import { getToken } from '../utils/cookieUtils';
import Nav from "../components/Nav";
import LoggedNav from "../components/LoggedNav";
import AddCardComponent from "../components/AddCard";

function AddCard(props) {
  return (
    <>
      {getToken() ? <LoggedNav customer={props.customer} /> : <Nav customer={props.customer} />}
      <AddCardComponent image={props.image} customer={props.customer} />
    </>
  );
}

export default AddCard;



